import React from "react";

import { Box } from "@mui/material";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { addCommasToNum } from "../utils";

const LinearGauge = ({
  percentage,
  tooltipTitle,
  legendTitle,
  over100,
  unlimited,
}) => {
  return (
    <Box sx={{ mt: 3 }}>
      <ResponsiveContainer width="100%" height={100}>
        <BarChart
          data={[
            {
              name: tooltipTitle,
              "0-60": 60,
              "60-80": 20,
              "80-100": 20,
              [legendTitle]: percentage,
            },
          ]}
          layout="vertical"
          barGap={0}
        >
          <XAxis
            type="number"
            tickFormatter={(val) => addCommasToNum(val, 3, 0)}
          />

          <YAxis type="category" dataKey="name" hide />

          <Tooltip
            formatter={(okay) => [
              unlimited ? "Unlimited" : `${over100 ? ">" : ""}${okay}%`,
              undefined,
            ]}
            labelFormatter={undefined}
          />
          <Legend />

          <Bar
            tooltipType="none"
            legendType="none"
            dataKey="0-60"
            stackId="a"
            barSize={20}
            fill="rgb(34,184,34)"
          />
          <Bar
            tooltipType="none"
            legendType="none"
            dataKey="60-80"
            stackId="a"
            barSize={20}
            fill="rgb(255,215,0)"
          />
          <Bar
            tooltipType="none"
            legendType="none"
            dataKey="80-100"
            stackId="a"
            barSize={20}
            fill="rgb(219,80,74)"
          />
          <Bar dataKey={legendTitle} barSize={10} fill="#457093" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default LinearGauge;
